import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

const SEO_REQUEST_TIMEOUT_MS = 800;

export const getPosts = async (allQueryParameters) => {
  const response = await axios.get(HOST_API_KEY + "/posts/", {
    params: allQueryParameters,
  });
  return response?.data;
};

export const getPlayVideos = async (allQueryParameters) => {
  const response = await axios.get(HOST_API_KEY + "/play/videos", {
    params: allQueryParameters,
  });
  return response?.data;
};

export const getPostById = async (postId) => {
  const response = await axios.get(HOST_API_KEY + "/posts/" + postId);
  return response?.data;
};

export const getPostByPublicId = async (publicId) => {
  const response = await axios.get(HOST_API_KEY + "/posts/public/" + publicId);
  return response?.data;
};

export const getPostsByUserIdForCreator = async (userId) => {
  const response = await axios.get(HOST_API_KEY + "/posts/creator/user/" + userId);
  return response?.data;
};

export const updatePost = async (data, postId) => {
  const response = await axiosInstanceWithToken.put(HOST_API_KEY + "/posts/" + postId, data);
  return response?.data;
};

export const deletePost = async (postId) => {
  const response = await axiosInstanceWithToken.delete(HOST_API_KEY + "/posts/" + postId);
  return response?.data;
};

export const searchPosts = async (searchQuery, options = {}) => {
  const response = await axios.get(HOST_API_KEY + "/posts/search", {
    params: {
      search: searchQuery,
      ...(options.params || {}),
    },
    signal: options.signal,
    timeout: options.timeout ?? 8000,
  });
  return response?.data;
};

export const increasePostImpressions = async (postId, data) => {
  const response = await axiosInstanceWithToken.post(
    HOST_API_KEY + "/posts/" + postId + "/increase-impression",
    data
  );
  return response?.data;
};

export const postLike = async (postId, data) => {
  const request = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/" + postId + "/like", data);
  return request?.data;
};

export const postDislike = async (postId, data) => {
  const request = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/" + postId + "/dislike", data);
  return request?.data;
};

export const getPostLikes = async (postId) => {
  const request = await axios.get(HOST_API_KEY + "/posts/" + postId + "/likes");
  return request?.data;
};

export const getPostComments = async (postId) => {
  const request = await axios.get(HOST_API_KEY + "/posts/" + postId + "/comments");
  return request?.data;
};

export const collectPost = async (data) => {
  const request = await axiosInstanceWithToken.post(HOST_API_KEY + "/collect", data);
  return request?.data;
};

export const deletePostCollect = async ({ userId, postId }) => {
  const request = await axiosInstanceWithToken.delete(
    HOST_API_KEY + "/collect/user/" + userId + "/post/" + postId
  );
  return request?.data;
};

export const updatePostCollect = async ({ collectId, albumId }) => {
  const request = await axiosInstanceWithToken.put(HOST_API_KEY + "/collect/" + collectId, {
    albumId,
  });
  return request?.data;
};

export const deleteMediaInBulk = async (data) => {
  const request = await axiosInstanceWithToken.delete(HOST_API_KEY + "/posts/media/delete/bulk", {
    params: data,
  });
  return request?.data;
};

export const getUsersForTagging = async () => {
  const request = await axios.get(HOST_API_KEY + "/users/list/tagging");
  return request?.data;
};

export const getAllUserFollowing = async (userId) => {
  const request = await axios.get(HOST_API_KEY + "/user/" + userId + "/following");
  return request?.data;
};

export const createPostPin = async (data) => {
  const request = await axiosInstanceWithToken.post(HOST_API_KEY + "/posts/create-pin", data);
  return request?.data;
};

export const deletePostPin = async (postId, userId) => {
  const request = await axiosInstanceWithToken.delete(
    HOST_API_KEY + "/posts/" + postId + "/delete-pin/" + userId
  );
  return request?.data;
};

export const getPostMedia = async (postId) => {
  const request = await axios.get(HOST_API_KEY + "/posts/" + postId + "/media");
  return request?.data;
};

export const getFollowingUsersPosts = async (userId, param) => {
  const request = await axios.get(
    HOST_API_KEY + "/followers-feeds/" + userId + "?page=" + param.page
  );
  return request?.data;
};
